<!-- @format -->

<template>
  <div>
    <div
      class="header-table flex items-center justify-between flex-wrap p-10 px-7"
    >
      <div class="flex items-center">
        <span class="font-bold text-lg text-blue-600">{{ title }}</span>
        <div class="mx-2"> 
          <slot name="detailTitle"/>
        </div>
      </div>
      <div class="flex items-center grow-0">
        <slot />
        <div class="relative">
          <v-text-field
            v-if="!notSearch"
            class="max-w-[200px] ml-5 mt-2"
            :value="value"
            @input="updateInput"
            filled
            dense
            rounded
            hide-details
            label="جستجو"
            single-line
          >
            <!--           <v-icon>mdi-magnify</v-icon>-->
          </v-text-field>
          <div class="iconSearchParent">
            <v-icon color="gray" size="25">mdi-magnify</v-icon>
          </div>
        </div>
        <filter-select
          v-if="!notFilter"
          class="ml-3"
          @filterSelect="$emit('updateSelect', $event)"
          :headers="filterHeaders"
          :headers-selected="filterHeadersSelect"
        />

        <vue-excel-xlsx
          v-if="!notExcl"
          :data="excData"
          :columns="excColumns"
          :file-name="$route.meta"
          :file-type="'xlsx'"
          :sheet-name="$route.meta"
        >
          <button
            type="button"
            class="flex items-center text-base focus:ring-2 ring-green-500 font-medium border-green-700 text-green-700 bg-green-50 w-9 h-9 justify-center rounded-md"
          >
            <v-icon style="color: inherit">mdi-file-compare</v-icon>
          </button>
          <!-- <img src="@/assets/svg/excel.svg" /> -->
        </vue-excel-xlsx>
        <slot name="newBtn" />

      </div>
    </div>
  </div>
</template>

<script>
import FilterSelect from "../FilterSelect";
export default {
  components: { FilterSelect },
  props: [
    "title",
    "notExcl",
    "notFilter",
    "notSearch",
    "value",
    "excData",
    "excColumns",
    "filterHeaders",
    "filterHeadersSelect",
  ],
  methods: {
    updateInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style>
.header-table .v-text-field .v-input__slot .v-text-field__slot input,
.header-table .v-text-field .v-input__slot .v-text-field__slot label {
  font-size: 13px !important;
}
.iconSearchParent {
  position: absolute;
  top: 15px;
  left: 30px;
}
</style>
